import React, { useEffect } from "react";
import { Typography } from "@material-ui/core";
import BadgeGoogle from "~/assets/icons/badges/get-in-googleplay.png";
import BadgeApple from "~/assets/icons/badges/get-in-applestore.svg";
import BackgroundImage from "~/assets/images/image-bg-bussines-page.jpg";
import { useTranslation } from "react-i18next";
import useStyles from "./styles";

const NoReservationsLink = () => {
	const classes = useStyles();
	const { t } = useTranslation();

	const handleGooglePlayClick = () => {
		window.open("https://play.google.com/store/apps/details?id=app.prit", "_blank");
	};

	const handleAppStoreClick = () => {
		window.open("https://apps.apple.com/br/app/prit/id1466577543", "_blank");
	};

	return (
		<div className={classes.container}>
			<div
				className={classes.topSection}
				style={{
					backgroundImage: `url(${BackgroundImage})`,
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
				}}>
				<div className={classes.peopleImageContainer}></div>
				<div className={classes.badgesContainer}>
					<img
						src={BadgeGoogle}
						alt="Baixar na Google Play"
						className={classes.badge}
						onClick={handleGooglePlayClick}
						style={{ paddingRight: "10px" }}
					/>
					<img src={BadgeApple} alt="Baixar na App Store" className={classes.badge} onClick={handleAppStoreClick} />
				</div>
			</div>

			<div className={classes.bottomSection}>
				<div className={classes.content}>
					<Typography className={classes.title}>
						{t("No appointments and link not associated")}
					</Typography>
					<Typography className={classes.subtitle}>
						{t("No appointments and link description")}
					</Typography>
					<Typography className={classes.instruction}>
						{t("No appointments and link instruction")}
					</Typography>
				</div>
			</div>
		</div>
	);
};

export default NoReservationsLink;

